import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/kaggle': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M304.2 501.5l1.4 7.6c-0.5 2-2.5 3-6 3h-66.9c-4 0-7.5-1.8-10.5-5.3l-110.5-140.6-30.8 29.3v109c0 5-2.5 7.5-7.5 7.5h-51.9c-5 0-7.5-2.5-7.5-7.5v-497c0-5 2.5-7.5 7.5-7.5h51.9c5 0 7.5 2.5 7.5 7.5v306l132.3-133.7c3.5-3.5 7-5.3 10.5-5.3h69.2c7 0 7.9 7.8 5.3 10.5l-139.8 135.3z'
      }
    ]
  }
})
